"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WhenDefinedCondition {
    constructor(expression) {
        this.expression = expression;
    }
    shouldDoValidation(input) {
        try {
            return typeof this.expression(input) !== "undefined";
        }
        catch (e) {
            return false;
        }
    }
}
exports.WhenDefinedCondition = WhenDefinedCondition;
//# sourceMappingURL=WhenDefinedCondition.js.map